import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'mb-myaccount-background',
  templateUrl: './mb-myaccount-background.component.html',
  styleUrls: ['./mb-myaccount-background.component.scss']
})
export class MbMyaccountBackgroundComponent {}
